// src/prototype/enterprise/EnterpriseModeToggle.tsx
// ============================================================
// The Standard ⟷ Enterprise pill, rendered INSIDE the profile (avatar) dropdown so it
// consumes no header real estate (X-1 · FIX 1). Same client (ACME), different entitlement —
// reuses the dva_demo_plan_override PATTERN via useEnterpriseMode.
//
// Enterprise mode is STICKY STATE: the pill (this dropdown) is the ONLY thing that
// enters/exits it. Once in Enterprise mode, navigating via the journey bar to storefront
// routes does NOT exit — the shell reads this sticky state, not the URL, so the navy bar
// persists. Flipping to Enterprise lands on /enterprise/portfolio (Portfolio default · FIX 3);
// flipping to Standard returns to the storefront.
//
// Pill styling matches Enterprise Prototype.dc.html (segOn/segOff).
// ============================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEnterpriseMode } from './useEnterpriseMode';

export const EnterpriseModeToggle: React.FC = () => {
  const { isEnterprise, setMode } = useEnterpriseMode();
  const navigate = useNavigate();

  const flip = (toEnterprise: boolean) => {
    setMode(toEnterprise ? 'enterprise' : 'standard');
    navigate(toEnterprise ? '/enterprise/portfolio' : '/opportunities');
  };

  const seg = (label: string, active: boolean, onClick: () => void, activeCls: string) => (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`flex-1 rounded-full px-3 py-1 text-[11px] transition-colors ${
        active ? activeCls : 'font-semibold text-[#717182] hover:text-[#18365E]'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="px-2 py-1.5">
      <div className="text-[10px] font-semibold uppercase tracking-wide text-slate-400 mb-1.5">
        ACME Health System
      </div>
      <div className="flex items-center gap-0.5 rounded-full bg-[#F5F7FA] p-0.5" role="group" aria-label="DVA mode">
        {seg('Standard', !isEnterprise, () => flip(false), 'font-bold bg-white text-[#18365E] shadow-sm')}
        {seg('Enterprise', isEnterprise, () => flip(true), 'font-bold bg-[#18365E] text-white shadow-sm')}
      </div>
    </div>
  );
};

export default EnterpriseModeToggle;
